import { render } from "./OutList.vue?vue&type=template&id=0a52887f"
import script from "./OutList.vue?vue&type=script&lang=js"
export * from "./OutList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__